import React, { useState, useEffect } from "react";
import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
import "../styles/cart.css";
import { BASE_URL } from "../api/api";

const CartPage = () => {
  const {
    cart,
    removeFromCart,
    updateQuantity,
    getCartSubtotal,
    getCartTotal,
    getCartCount,
    clearCart,
    appliedCoupon,
    discount,
    applyCoupon,
    removeCoupon,
    submitOrder,
    tableNo,
  } = useCart();

  const navigate = useNavigate();
  const { activeOrder } = useCart();
  const disabled = !!activeOrder;

  const [isPlacingOrder, setIsPlacingOrder] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [couponMessage, setCouponMessage] = useState("");
  const [showCouponInput, setShowCouponInput] = useState(false);
  // const [tableId, setTableId] = useState(null);

  const subtotal = getCartSubtotal();
  const total = getCartTotal();

  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   const table = params.get("table");
  //   if (table) setTableId(table);
  // }, []);

  // Coupon handler
  const handleApplyCoupon = async () => {
    if (!couponCode.trim()) {
      setCouponMessage("Please enter coupon code");
      return;
    }

    const result = await applyCoupon(couponCode);
    setCouponMessage(result.message);

    if (result.success) {
      setCouponCode("");
      setShowCouponInput(false);
      setTimeout(() => setCouponMessage(""), 3000);
    }
  };

  // ORDER FUNCTION
  const handlePlaceOrder = async () => {
    if (cart.length === 0) return alert("Cart is empty");
    if (!tableNo) return alert("Please scan table QR first");

    try {
      setIsPlacingOrder(true);

      const result = await submitOrder();

      if (!result.success) {
        alert(result.message); // 👈 THIS is what you asked about
        return;
      }

      clearCart();
      navigate(`/order-tracking/${result.orderId}`);
    } catch (err) {
      console.error("Order Error:", err);
      alert("Order failed");
    } finally {
      setIsPlacingOrder(false);
    }
  };
  useEffect(() => {
    if (activeOrder) {
      navigate(`/order-tracking/${activeOrder}`);
    }
  }, [activeOrder]);

  return (
    <div className="cart-page">
      {/* HEADER */}
      <div className="cart-header">
        <h2>My Cart ({getCartCount()} items)</h2>

        {cart.length > 0 && (
          <button className="clear-btn" onClick={clearCart}>
            Clear All
          </button>
        )}
      </div>

      {/* EMPTY STATE */}
      {cart.length === 0 ? (
        <div className="empty-cart">
          <div className="empty-icon">🛒</div>
          <h3>Your cart is empty</h3>
          <p>Add something delicious 🍕</p>
          <button onClick={() => navigate("/")}>Browse Menu</button>
        </div>
      ) : (
        <>
          {/* CART ITEMS */}
          <div className="cart-items">
            {cart.map((item, index) => (
              <div className="cart-card" key={`${item.id}-${index}`}>
                <img
                  src={
                    item.image
                      ? `${BASE_URL}/${item.image}`
                      : "/assets/images/product/default.png"
                  }
                  alt={item.item_name}
                />

                <div className="cart-info">
                  <h4>{item.item_name}</h4>
                  <p className="price">₹{item.price}</p>

                  <div className="qty-controls">
                    <button
                      onClick={() =>
                        updateQuantity(item.id, item.qty - 1, item.variant)
                      }>
                      -
                    </button>

                    <span>{item.qty}</span>

                    <button
                      onClick={() =>
                        updateQuantity(item.id, item.qty + 1, item.variant)
                      }>
                      +
                    </button>

                    <button
                      className="remove-btn"
                      onClick={() => removeFromCart(item.id, item.variant)}>
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* ORDER SUMMARY */}
          <div className="order-summary">
            <h3>Bill Details</h3>

            {/* ITEM BREAKDOWN */}
            <div className="item-breakdown">
              {cart.map((item, index) => (
                <div className="bill-item" key={index}>
                  <div>
                    <p className="item-name">{item.item_name}</p>
                    <p className="item-sub">
                      ₹{item.price} × {item.qty}
                    </p>
                  </div>

                  <div className="bill-price">₹{item.price * item.qty}</div>
                </div>
              ))}
            </div>

            <hr />

            {/* SUBTOTAL */}
            <div className="summary-row">
              <span>Subtotal</span>
              <span>₹{subtotal}</span>
            </div>

            {/* DISCOUNT */}
            {discount > 0 && (
              <div className="summary-row discount">
                <span>Discount ({appliedCoupon})</span>
                <span>-₹{discount}</span>
                <button onClick={removeCoupon}>Remove</button>
              </div>
            )}

            {/* TOTAL */}
            <div className="summary-row total">
              <span>Total</span>
              <span>₹{total}</span>
            </div>

            {/* COUPON */}
            {!appliedCoupon && (
              <div className="coupon-section">
                {!showCouponInput ? (
                  <button onClick={() => setShowCouponInput(true)}>
                    Apply Coupon
                  </button>
                ) : (
                  <div className="coupon-input">
                    <input
                      value={couponCode}
                      onChange={(e) => setCouponCode(e.target.value)}
                      placeholder="Coupon code"
                    />

                    <button onClick={handleApplyCoupon}>Apply</button>

                    <button onClick={() => setShowCouponInput(false)}>
                      Cancel
                    </button>
                  </div>
                )}

                {couponMessage && (
                  <p className="coupon-message">{couponMessage}</p>
                )}
              </div>
            )}
          </div>

          {/* FIXED CHECKOUT BAR */}
          <div className="place-order-container">
            <button
              className="place-order-btn"
              onClick={handlePlaceOrder}
              disabled={isPlacingOrder}>
              {isPlacingOrder ? "Placing Order..." : `Place Order • ₹${total}`}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default CartPage;
